import { AxiosResponse } from 'axios';
import {
  all,
  call,
  CallEffect,
  fork,
  put,
  PutEffect,
  takeEvery,
} from 'redux-saga/effects';
import FaraGostarDynamicHttp from '../../api/FaraGostarDynamicHttp';
import { ActionTypes } from '../../constants/ActionTypes';
import { ShowError, ShowSuccess } from '../../helper/Alert';
import { IAddReminderParams } from '../../interfaces';
import { getLocaleMsg } from '../../lngProvider';
import {
  fetchGetReminderReceiversSuccess,
  fetchReminderSuccess,
  onGetReminder,
} from '../actions/Reminder';

const getReminder = async (
  page: number | null,
  categoryId: number,
  searchText: string | null,
) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(`reminder/GetReminderAndNoteForPwa?pageIndex=${page}&categoryId=${categoryId}`);
};

const changeReminder = async (parameters: any) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post('reminder/changeNotificationStatus', parameters);
};

const addReminder = async (parameters: IAddReminderParams) => {
  const http = await FaraGostarDynamicHttp();
  return await http.post('notify/addReminder', parameters);
};

const getReminderReceivers = async (parameters: any) => {
  const http = await FaraGostarDynamicHttp();
  return await http.get(
    `notify/getReminderReceivers?letterCode=${parameters.letterCode}&searchText=`,
  );
};

function* fetchReminderRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedReminder = yield call(
      getReminder,
      action.payload.page,
      action.payload.categoryId,
      action.payload.searchText,
    );

    yield put(
      fetchReminderSuccess({
        append: action.payload.append,
        reminder: fetchedReminder.data,
      }),
    );
  } catch (error) {
    // return ShowError("", error);
  }
}

export function* fetchReminder() {
  yield takeEvery(ActionTypes.GET_REMINDER, fetchReminderRequest);
}

// change reminder
function* fetchChangeReminderRequest(action: any) {
  const messages = getLocaleMsg();
  try {
    yield call(changeReminder, action.payload);
    ShowSuccess(messages['messages.operationWasSuccessful'], '');
    yield put(
      onGetReminder({
        page: 0,
        categoryId: 1,
        searchText: null,
        append: false,
        isNotify: false,
      }),
    );
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchChangeReminder() {
  yield takeEvery(ActionTypes.CHANGE_REMINDER, fetchChangeReminderRequest);
}

function* fetchReminderReceiversRequest(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<any>>
  | PutEffect<{ type: ActionTypes; payload: any }>,
  void,
  AxiosResponse<any>
> {
  try {
    const fetchedReminderReceivers = yield call(
      getReminderReceivers,
      action.payload,
    );
    yield put(fetchGetReminderReceiversSuccess(fetchedReminderReceivers.data));
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchReminderReceivers() {
  yield takeEvery(
    ActionTypes.GET_REMINDER_RECEIVERS,
    fetchReminderReceiversRequest,
  );
}

function* fetchAddReminderRequest(action: any) {
  const messages = getLocaleMsg();
  try {
    yield call(addReminder, action.payload);
    ShowSuccess(messages['messages.operationWasSuccessful'], '');

    yield put(
      onGetReminder({
        page: 0,
        categoryId: 1,
        searchText: null,
        append: false,
        isNotify: false,
      }),
    );
  } catch (error) {
    return ShowError('', error);
  }
}

export function* fetchAddReminder() {
  yield takeEvery(ActionTypes.ADD_REMINDER, fetchAddReminderRequest);
}

export default function* rootSaga() {
  yield all([
    fork(fetchReminder),
    fork(fetchChangeReminder),
    fork(fetchReminderReceivers),
    fork(fetchAddReminder),
  ]);
}
